module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chaptitle1"
  }, [_c('a', {
    attrs: {
      "id": "intro"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _vm._v("Introduction")]), _vm._v(" "), _c('h1', {
    staticClass: "chap-subtitle"
  }, [_c('a', {
    attrs: {
      "id": "intro1"
    }
  }), _vm._v("Breathe, Pause, Breathe,"), _c('br'), _vm._v(" Pause, Breathe . . .")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("The gift of a somewhat retired life is having the time to fully appreciate the power of now, the power of nothingness. Which is, of course, the power of everythingness. This is a space I'm growing into in these days and weeks, hopefully months and years too, since turning seventy-five. Everythingness—what a glorious doorway to the unfolding of a life already well lived, and yet one that is ripe for far more living.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Since the age of thirteen, I have been employed. I have also been an alcoholic since that age. Until now, I had not considered that parallel in my life. Does the alcoholism in fact “complement” the work life? I think it did for me. The drink was quite often the reward for work well done. As I aged, the alcohol also fueled the act of working. Seldom did I grade papers, develop strategic plans, or study for exams without a glass of Jack Daniel's by my side. It eased the transition between thoughts and words on the page. It eased all the years it took to become a PhD.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Throughout the journey from drink number one to the celebration of thirty-eight years of abstinence, I passed through many portals of life, and seldom did I take the time to breathe, pause, and breathe again. I simply rushed by the events, the people, the inclinations to make choice A rather than choice B. I had never considered the idea that what caught my attention had been “sent” from on high.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Today, my faith is a thread that I have busily knit into the tapestry that is mine, and only mine. Knitting and breathing and "), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _vm._v("pausing I know to be my main “assignments.” I say assignment because that word implies a necessary act. The act of breathing is, of course, mandatory for us all. The gift of pausing is an act to be cultivated, daily, hourly, even minute by minute. Cultivated not unlike the garden of vegetables we hover over after planting, pulling the hungry weeds stealing the moisture away from the roots feeding the carrots and the lettuce and the ruby red tomatoes. And knitting? Well, knitting the myriad threads is done automatically. By you, by me, by every creature of the forests and the streams.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("The many flowers along the side of one's house scream for our attention in the midst of the breathing and pausing that have become our work, as the years draw us into the future moments, moments that have our names indelibly etched on them. Having these future moments call me to attention is one of the rewards of a life well lived, a life that has learned to be willing to listen for the next invitation, a life that knows there were no accidents along the way and none will follow me into the future.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("My certainty that the divine has always been the creator of the appointments I have been inclined to make and keep has, in its way, given me the confidence coupled with the willingness to breathe, pause, and breathe again at this time, at this age, with these people who share my journey. Life is a long time from being over, but it's also mandatory, from my current perspective, to take the time to breathe, pause, and breathe again while the mood is still calling me. Can you allow it to call to you too?")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('b', [_vm._v("A pause is a suspension of activity, a time of temporary disengagement when we are no longer moving toward any goal . . .")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquoteright"
  }, [_c('b', [_vm._v("—Tara Brach")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U001.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _vm._v("Right now, before reading any further, take a few moments to yourself to breathe, pause, and breathe again. Sit alone in a room that comforts you. Sit quietly. Close your eyes. Enjoy the moment.")]), _vm._v(" "), _c('p', {
    staticClass: "text3"
  }, [_vm._v("1. Upon “awaking” from this silence, what thoughts come first to mind? Share these thoughts in your journal.")]), _vm._v(" "), _c('p', {
    staticClass: "text3"
  }, [_vm._v("2. What most pleases you about this exercise? Share this thought in your journal too.")]), _vm._v(" "), _c('p', {
    staticClass: "text3"
  }, [_vm._v("3. Will you set aside time to repeat this tomorrow? Why or why not?")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U001.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6aab171d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/06_introduction.vue
// module id = 75
// module chunks = 0